<div class="flex-center">
  <div class="contentWidth">
    <div style="height: calc(90vh - 100px); overflow-y: auto;">
      <form [formGroup]="CPForm" autocomplete="off">
        <ng-container formArrayName="CPRows">
          <table #objTable
            mat-table
            matSort
            [dataSource]="dataSource"
            class="table-add-butt-header-orange mat-elevation-z8 mat-table-custom">

            <ng-container matColumnDef="headertitle">
              <th class="title-col" mat-header-cell *matHeaderCellDef colspan="4">
                <div class="pull-left">
                  <h4>Manufacturing Center Products</h4>
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="headeraddbutton">
              <th class="butt-col" mat-header-cell *matHeaderCellDef>
                <div class="OrangeButton">
                  <button mat-raised-button (click)="addNewRow()"
                    matTooltip="Add Product" class="button-color-fix pull-right">
                    <mat-icon class="icon-color-fix icon-padding-fix">add_box</mat-icon>
                  </button>
                </div>
              </th>
            </ng-container>

            <!-- Product Code Column -->
            <ng-container matColumnDef="productcode">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="productcode" style="width:25%">Product Code</th>
              <td mat-cell *matCellDef="let element" style="width:25%">
                @if (!element.isNewRow) {
                  <div [innerHTML]="element.productCode"></div>
                }
                @if (element.isNewRow) {
                  <mat-form-field style="width: 100%">
                    <input matInput type="text"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="element.productCode"
                      maxlength="30"
                      matTooltip="Max 30 characters" />
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <!-- Center Column -->
              <ng-container matColumnDef="center">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="center" style="width:15%">MFG Center</th>
                <td mat-cell *matCellDef="let element" style="width:15%">
                  @if (element.isEditable) {
                    <div [innerHTML]="getCenterName(element.mfgCenterId)"></div>
                  }
                  @if (!element.isEditable) {
                    <mat-form-field floatLabel="auto">
                      <mat-select style="min-width: 200px; color:red" [(ngModel)]="element.mfgCenterId"
                        [ngModelOptions]="{standalone: true}">
                        <mat-option [value]="-1" [disabled]="true">Select</mat-option>
                        @for (center of availableCenters; track center) {
                          <mat-option [value]="center.centerId">
                            {{ center.centerName }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <!-- Product Usage Column-->
              <ng-container matColumnDef="productusage">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="productusage" style="width:25%">Product Usage</th>
                <td mat-cell *matCellDef="let element" style="width:25%">
                  @if (element.isEditable) {
                    <div [innerHTML]="getProductUsageName(element.productUsageId)"></div>
                  }
                  @if (!element.isEditable) {
                    <mat-form-field floatLabel="auto">
                      <mat-select style="min-width: 200px; color:red" [(ngModel)]="element.productUsageId"
                        [ngModelOptions]="{standalone: true}">
                        <mat-option [value]="-1" [disabled]="true">Select</mat-option>
                        @for (pUsage of availableProductUsages; track pUsage) {
                          <mat-option [value]="pUsage.productUsageID">
                            {{ pUsage.name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <!-- Product Name Column -->
              <ng-container matColumnDef="productname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="productname" style="width:25%">Product Name</th>
                <td mat-cell *matCellDef="let element" style="width:25%">
                  @if (element.isEditable) {
                    <div [innerHTML]="element.productName"></div>
                  }
                  @if (!element.isEditable) {
                    <mat-form-field style="width: 100%">
                      <input matInput type="text"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="element.productName"
                        maxlength="50"
                        matTooltip="Max 50 characters" />
                      </mat-form-field>
                    }
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef style="width:10%"></th>
                  <td mat-cell *matCellDef="let element" style="width:10%">
                    @if (!element.isEditable) {
                      <button mat-icon-button
                        matTooltip="Cancel Changes"
                        color="warn"
                        (click)="resetRowByID(element.manufacturingCenterProductID)">
                        <mat-icon class="actionButtons">rotate_left</mat-icon>
                      </button>
                    }
                    @if (element.isEditable) {
                      <button mat-icon-button
                        matTooltip="Edit"
                        color="primary"
                        (click)="editRowByID(element.manufacturingCenterProductID)">
                        <mat-icon class="actionButtons">edit</mat-icon>
                      </button>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="savefooter">
                  <th mat-footer-cell *matFooterCellDef colspan="5">
                    <div class="OrangeButton">
                      <button mat-raised-button type="submit" (click)="onSave()"
                        [disabled]="!anyChange()"
                        [matTooltip]="anyChange()? 'Save changes' : 'Save disabled'"
                        class="button-color-fix pull-right">
                        Save
                        <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
                      </button>
                    </div>
                  </th>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="['headertitle', 'headeraddbutton']; sticky: true" class="stickyTopz100"></tr>
                <tr class="col-headers" mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" [class.alternative2]="!row.isEditable"></tr>
                <tr mat-footer-row *matFooterRowDef="['savefooter']; sticky: true"></tr>
              </table>
            </ng-container>
          </form>
        </div>
      </div>
    </div>